import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
    selector: 'self-ins-coverage',
    templateUrl: './coverage-page.component.html',
    styleUrls: ['./coverage-page.component.scss']
})
export class CoveragePageComponent{
    public qnum = 0;
    public qsuffix = '';

    public constructor(private activeRouter: ActivatedRoute,
        private router: Router) { }

    public gotoPage(pageUrl: string) {
        this.router.navigate([`/${pageUrl}`], {
            queryParams: {
                qnum: this.qnum,
                qsuffix: this.qsuffix
            }
        });
    }

    ngOnInit(): void {
        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];
          });
    }
}
